import React from 'react';

/**
 * Responsive multi-column form body. Lays out its child <Form.Group>s in a grid
 * that fits as many ~240px columns as the width allows and collapses to a single
 * column on narrow screens. Replaces the single-column, full-width field stack.
 *
 * Give any field that needs the whole row (textareas, wide selects) the
 * `crud-form-span-full` class on its <Form.Group>. Wrap the submit/cancel
 * buttons in <FormActions> so they sit on their own full-width row.
 */
export const FormGrid = ({ className = '', children }) => (
  <div className={`crud-form-grid ${className}`.trim()}>{children}</div>
);

/**
 * Full-width footer row for a form's action buttons.
 */
export const FormActions = ({ children }) => (
  <div className="crud-form-actions">{children}</div>
);

export default FormGrid;
